/**
 * @generated SignedSource<<fd8695f633f59aa70c3d5581ce9df231>>
 * @relayHash 07c5f2ec974f57c6c845576766f03daf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 955715b5ed61244f6a686c10ecfeb0d267b14615b4f208ac5098e990e624ac43

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PolarisProjectArchivedIdeasPageQuery } from './PolarisProjectArchivedIdeasPageQuery.graphql';

const node: PreloadableConcreteRequest<PolarisProjectArchivedIdeasPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "955715b5ed61244f6a686c10ecfeb0d267b14615b4f208ac5098e990e624ac43",
    "metadata": {},
    "name": "PolarisProjectArchivedIdeasPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
